import {Component} from '@angular/core';
import {ApexChart, NgApexchartsModule} from "ng-apexcharts";
import {IcfClause, Study} from "@ctms/api/api.interfaces";
import {ApiService} from "@ctms/api.service";
import {DatePipe, NgIf} from "@angular/common";
import {WithdrawnComponent} from "../withdrawn/withdrawn.component";
import {CompleteComponent} from "../complete/complete.component";
import {Participant} from '@models/participant.model';
import {SpinnerComponent} from "@shared/components/spinner/spinner.component";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'study-overview',
    imports: [
        NgApexchartsModule,
        DatePipe,
        NgIf,
        WithdrawnComponent,
        CompleteComponent,
        SpinnerComponent
    ],
    standalone: true,
    templateUrl: './study-overview.component.html'
})
export class StudyOverviewComponent {

    participant: Participant
    study: Study
    icfClauses: Map<number, IcfClause> = new Map()

    loading: boolean = false

    chart: { series: Array<Number>, chart: ApexChart, labels: Array<String> } = {
        series: [0, 0],
        chart: {
            type: 'pie',
            width: 300,
        },
        labels: ['Scheduled', 'Completed'],
    }

    constructor(
        private apiService: ApiService,
        private toastr: ToastrService
    ) {
    }

    refresh(participant: Participant) {
        if (!participant) {
            return
        }
        this.participant = participant
        this.chart.series = [this.participant.totalTasksScheduled, this.participant.totalTasksCompleted]
        this.apiService.getStudy(this.participant.studySite.study.id).subscribe(response => {
            this.study = response.data
            this.study.icfClauses.forEach(item => {
                this.icfClauses.set(item.id, item)
            })
        })
    }

    resendSignedICF() {
        if (!this.participant) {
            return
        }
        this.loading = true
        this.apiService.resendSignedICF(this.participant.id).subscribe({
            next: (response) => {
                this.loading = false
                this.toastr.success(response.message);
            },
            error: (e) => {
                this.toastr.error("Only future dates are allowed.");
                this.loading = false
            }
        })
    }

    downloadICF() {
        if (!this.participant) {
            return
        }
        this.loading = true
        this.apiService.downloadICF(this.participant.id).download(() => {
            this.loading = false
        })
    }
}
